module.exports = __webpack_public_path__ + "img/story4.8c345e08.webp";